var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "join-container" },
    [
      _c("address-section", {
        attrs: {
          "order-num": _vm.orderId,
          "current-shipping": _vm.shippingAddress,
          "current-billing": _vm.billingAddress,
          "shipping-same-as-billing": _vm.shippingSameAsBilling,
          pickup: _vm.pickupComputed,
          disabled: _vm.orderLocked,
        },
        on: {
          "update:pickup": function ($event) {
            _vm.pickupComputed = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "section",
        { ref: "cardFormWrapper", staticClass: "payment-section" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("card-display", {
            on: {
              "update-payer": _vm.updatePayer,
              error: _vm.paymentMethodError,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.allowOrderNow && !_vm.orderId
        ? _c(
            "section",
            { staticClass: "order-one-now-section" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "b-container",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("div", { staticClass: "section-card" }, [
                          _c("div", { staticClass: "section-card-msg" }, [
                            _vm._v(
                              "\n              In addition to receiving your Club Order on the next planned shipping date "
                            ),
                            _c("div", { staticClass: "shipping-date" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.nextShippingDate) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(
                              " we will send you the first delivery immediately.\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "section-card-toggle" },
                            [
                              _vm.showOrderNow
                                ? _c("swoggle", {
                                    attrs: {
                                      "label-on": "Yes",
                                      "label-off": "No",
                                    },
                                    model: {
                                      value: _vm.orderOneNowComputed,
                                      callback: function ($$v) {
                                        _vm.orderOneNowComputed = $$v
                                      },
                                      expression: "orderOneNowComputed",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.orderOneNowComputed
                                ? _c("div", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      "\n                Your card will be charged straight away.\n              "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.orderId
        ? _c(
            "section",
            { staticClass: "dob-section" },
            [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "b-container",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c(
                          "div",
                          { staticClass: "section-card" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c("label", [
                                  _vm._v("Please enter your date of birth"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "no-ssr",
                                  [
                                    _c("datepicker", {
                                      attrs: {
                                        required: true,
                                        "input-class": _vm.dateclass,
                                        placeholder: "DD MMM YYYY",
                                        format: "DD MMM YYYY",
                                        "latest-year":
                                          new Date().getFullYear() - 18,
                                      },
                                      model: {
                                        value: _vm.dateOfBirth,
                                        callback: function ($$v) {
                                          _vm.dateOfBirth = $$v
                                        },
                                        expression: "dateOfBirth",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "section-card-msg" }, [
                              _vm._v(
                                "\n              Click on the Calendar to choose your day, month and year to confirm you are over 18.\n            "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("somnambulist-ui-order-summary"),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "joinButton",
          staticClass: "join-button-container",
          class: { "join-enabled": _vm.saveButtonEnabled },
        },
        [
          _vm.submitting
            ? _c(
                "div",
                { staticClass: "join-button" },
                [
                  _c("b-spinner", { attrs: { variant: "light" } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "in-progress-text" }, [
                    _vm._v("\n        In Progress...\n      "),
                  ]),
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "join-button",
                  on: {
                    click: () =>
                      _vm.orderId ? _vm.submitOrderChange() : _vm.trySubmit(),
                  },
                },
                [
                  _c("div", { staticClass: "join-text" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.joinButtonText) + "\n      "
                    ),
                  ]),
                ]
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-title" }, [
      _c("h2", [_vm._v("Payment Method")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-title" }, [
      _c("h2", [_vm._v("WHY WAIT! GET ONE NOW")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-title" }, [
      _c("h2", [_vm._v("Date Of Birth")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }